import { sendExtensibleRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import { AlmeUIMessage } from '@alme/ui-web/types/response';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import { AlmeResponseV5 } from '@alme/types/response/AlmeResponse';
import { ResponseAction } from '@alme/types/response/ResponseAction';

export default class GetConversationTranscriptResponseActionHandler{
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>){
        this._store = store;
    }

    getReducer() {
        return (state = {}) => { return state; }
    }

    process(message: AlmeUIMessage) {
        if (!this.doesHandle(message)) return message;

        const input = {
            messageType: this._settings.messageConstants.extensibleRequest,
            messageSource: this._settings.ResponseActions.getConversationTranscript.actionName,
            messageLimit: this._settings.History.messageLimit,
            includeRevertedEntries: this._settings.History.includeRevertedEntries,
            endpoint: this._settings.ExtensibleAlmeAPI.GetHistoryEndpoint
        };

        sendExtensibleRequest(input, 'POST');

        return message;
    }

    doesHandle(message: AlmeUIMessage) {
        return this.hasResponseActionWithName(
            message.response as AlmeResponseV5,
            this._settings.ResponseActions.getConversationTranscript.actionName);
    }

    hasResponseActionWithName(response: AlmeResponseV5, targetName: string) {
        if(!response || !(response.responseActions) || response.responseActions.length === 0) return false;
        let responseAction = this.findResponseActionWithName(response.responseActions, targetName);
        return (responseAction);
    }

    findResponseActionWithName(responseActions: ResponseAction[], targetName: string) {
        for (var i = 0; i < responseActions.length; i++) {
            if (responseActions[i].Name === targetName) {
                return responseActions[i];
            }
        }
        return null;
    }
}




// WEBPACK FOOTER //
// ./modules/get-conversation-transcript/message-handlers/response-action-handler.ts